import { CHAT_CLASS } from 'src/types/enum';

export const HISTORY_EXCLUDED_CLASSES = [
  CHAT_CLASS.DATA_ANALYST,
  CHAT_CLASS.PROJECT
];

export const HEADER_ROW_HEIGHT = 28;
export const ITEM_ROW_HEIGHT = 38;
